





























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ConfirmDialog from "@/components/dialogs/confirmDialog.vue";
import * as _ from "lodash";
import { PostContents } from "@/request/zhuanbingshujuku";
import TemplateTransfer from "./template-transfer.vue";
@Component({
  components: {
    TemplateTransfer,
    ConfirmDialog,
  },
})
export default class CdrDetailCustom extends Vue {
  @Prop()
  private name: any;
  @Prop()
  private patient: any;
  @Prop()
  private templateInfo: any;
  @Prop()
  private zhenci: any;
  @Prop()
  private content: any;
  private cContent: any = {};
  private ifShowConfirm: boolean = false;
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private get templates() {
    return this.templateInfo["模板"];
  }
  @Watch("content", { immediate: true, deep: true })
  private contentChange(content) {
    this.$set(this, "cContent", content);
  }
  /**
   * @description 切换当前数据
   */
  private changeCurrentContent(c) {
    if (this.ifCompose) {
      this.$message.warning("当前数据尚未保存，请先保存");
      return;
    } else {
      this.cContent = c;
      this.$forceUpdate();
    }
  }
  /**
   * @description 开始编辑
   */
  private startCompose() {
    this.$store.commit("updateifCompose", true);
  }
  /**
   * @description 保存量表数据
   */
  private save() {
    return new Promise((resolve, reject) => {
      console.log(this.templateInfo);
      if (this.templateInfo["名称"] === "康复方案") {
        this.$message.success("保存成功");
        resolve();
      }
      const params: any = {
        content_id: this.cContent.content_id,
        patient_id: this.patient.patient_id,
        project_id: this.templateInfo.project_id,
        group_id: this.templateInfo.group_id,
        template_id: this.templateInfo.template_id,
        zhenci_id: this.zhenci.zhenci_id,
        data: this.cContent.data,
        create_time: this.cContent["create_time"],
      };
      PostContents(this, params).then((data: any) => {
        this.cContent = data;
        this.$message.success("保存成功");
        this.$store.commit("updateIfCompose", false);
        this.$emit("refresh");
        resolve();
      });
    });
  }
}
